import { combineReducers } from "redux";
import loaderReducer from "./common/loaderReducer";
import globalsReducer from "./common/globalsReducer";
import userReducer from "./user/userReducer";

const rootReducer = combineReducers({
  loader: loaderReducer,
  user: userReducer,
  global: globalsReducer,
});

export default rootReducer;
